// Models
import { createAssessmentPlanningStoreDefaultModel } from './planning.store'

const assessmentPlanningModels = {
  assessmentPlanning: createAssessmentPlanningStoreDefaultModel(),
}

export { assessmentPlanningModels }
